<template>
  <div
    class="input-group-addon form-control"
    :class="[width ? `!w-${width}` : '', { 'read-only': readonly }]"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
defineProps({
  width: {
    type: String,
    default: 'auto'
  },
  readonly: {
    type: Boolean,
    default: false
  }
})
</script>

<style>
.input-group-addon {
  color: var(--text-quaternary);
  flex-shrink: 0;
  flex-grow: 0;
  min-width: fit-content;
}
</style>
